<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.form.escalasComaGlasgow.concat(data.model.escalasComaGlasgow ? data.model.escalasComaGlasgow : [])"
            hide-filters
            hide-pagination
            tag="div"
        >
            <template v-slot:cell(info)="row">
                <div v-if="Number.isInteger(row.item.id)">
                    <rkm-icon
                        :id="`pronto-atendimento-observacao-escala-coma-glasgow-${row.item.id}`"
                        class="mr-2"
                        icon="info-circle"
                    />

                    <rkm-popover
                        :target="`pronto-atendimento-observacao-escala-coma-glasgow-${row.item.id}`"
                        triggers="hover"
                    >
                        <div>{{ row.item.centroCusto.setor.nome }}</div>
                        <div><rkm-icon icon="user" /> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                        <div>Class. risco: {{ row.item.classificacaoRisco.nome }}</div>
                    </rkm-popover>

                    {{ row.item.dataHora }}
                </div>
            </template>

            <template v-slot:cell(aberturaOcular.pontos)="{ value }">
                {{ value > 0 ? value : 'NT' }}
            </template>

            <template v-slot:cell(respostaVerbal.pontos)="{ value }">
                {{ value > 0 ? value : 'NT' }}
            </template>

            <template v-slot:cell(respostaMotora.pontos)="{ value }">
                {{ value > 0 ? value : 'NT' }}
            </template>

            <template v-slot:cell(reatividadePupilar.pontos)="{ value }">
                {{ value > 0 ? '-' : '' }}{{ value }}
            </template>

            <template v-if="data.model.escalasComaGlasgow != null" v-slot:cell(actions)="row">
                <rkm-button
                    :disabled="!row.item.observacoes"
                    @click="$refs.ModalObservacao.open(row.item.observacoes)"
                    small
                >
                    <rkm-icon icon="comment" />
                </rkm-button>

                <rkm-button
                    :disabled="Number.isInteger(row.item.id)"
                    @click="$refs.Modal.open(row.item)"
                    color="primary"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="Number.isInteger(row.item.id)"
                    @click="handleDestroy(row.item)"
                    color="danger"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />

        <modal-observacao ref="ModalObservacao" />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'
import ModalObservacao from './components/observacao/Modal'

export default {
    components: { Modal, ModalObservacao },
    computed: {
        fields: function() {
            const fields = [
                { key: 'info', label: '#', class: 'col-min' },
                { key: 'aberturaOcular.pontos', label: 'Ocular', class: 'text-center' },
                { key: 'respostaVerbal.pontos', label: 'Verbal' , class: 'text-center'},
                { key: 'respostaMotora.pontos', label: 'Motora' , class: 'text-center'},
                { key: 'reatividadePupilar.pontos', label: 'Pupilar' , class: 'text-center'},
                { key: 'pontuacao', label: 'Pontuação' , class: 'text-center'},
                { key: 'resultado', label: 'Resultado' , class: 'text-center'},
            ]

            if (this.data.model.escalasComaGlasgow != null) {

                fields.push({ key: 'actions', label: 'Ações', class: 'col-min text-center' })
            }

            return fields
        }
    },
    methods: {
        handleDestroy(item) {
            const destroy = () => new Promise(resolve => {
                const index = this.data.model.escalasComaGlasgow.findIndex(anotacao => anotacao.id === item.id)
                resolve(this.data.model.escalasComaGlasgow.splice(index, 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>